import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { HelmetProvider } from 'react-helmet-async';
import App from './App.tsx';
import { LocalSEOProvider } from './components/SEO/LocalSEOProvider.tsx';
import { ThemeProvider } from './contexts/ThemeContext.tsx';
import './index.css';

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <ThemeProvider>
      <HelmetProvider>
        <LocalSEOProvider>
          <App />
        </LocalSEOProvider>
      </HelmetProvider>
    </ThemeProvider>
  </StrictMode>
);
